const updateRow = ({ object, key, items }) => {
  const {
    statusId,
    statusName,
    statusColor,
  } = object;

  return items.map(item =>
    item.id === key ? { ...item, statusId, statusName, statusColor } : item
  );
}

export default updateRow;
